import React, {useCallback, useContext, useEffect, useState, useMemo} from "react";
import {IconGOML, IconLogoAMD, IconLogoCorsair, IconLogoGigabyte, IconLogoNvidia} from "../../contants/icons";
import IconClose from "../IconButton/IconClose/IconClose";
import IconButton from "../IconButton/IconButton";
import TitledName from "../TitledName/TitledName";
import classNames from "classnames";
import ScrollableArea from "../ScrollableArea/ScrollableArea";
import AppContext, {ACTION_ISOLATE_ITEM, ACTION_ISOLATE_ITEM_DISABLED, ISOLATED_PRODUCT} from "../../store";
import PropTypes from 'prop-types';
import './styles/ProductDetails.scss';
import {checkIsBundle} from "../../helpers";
import {TEXT_GOMLVL_LONG} from "../../contants/common";
import API from "../../api";
import useStreamActionsSingle from "../../hooks/useStreamActionsSingle";
import {SYSTEM_ID_TOGGLE_INSPECT} from "../../contants/presets";
import get from 'lodash.get'

const getProductsBrandLogo = title => {
	return [
		{keyWord: 'edition', iconData: {IconComponent: IconGOML, height: 59}},
		{keyWord: 'corsair', iconData: {IconComponent: IconLogoCorsair, height: 33}},
		{keyWord: 'gigabyte', iconData: {IconComponent: IconLogoGigabyte, height: 19}},
		{keyWord: 'nvidia', iconData: {IconComponent: IconLogoNvidia, height: 45}},
		{keyWord: 'amd', iconData: {IconComponent: IconLogoAMD, height: 64}},
	].find(el => ~(title || '').toLowerCase().indexOf(el.keyWord));
};

export default function ProductDetails() {
	const {
		products,
		isProductDetailsOpen,
		toggleProductsDetails,
		isStickyPanelCollapsed,
		toggleStickyPanel,
		activeTabId,
		streamStore,
		productDetailsId,
		setProductDetailsId,
		setStreamStore,
		setActiveTabId,
		getAllSelections,
	} = useContext(AppContext);
	const [iconData, setIconData] = useState(null);
	const [data, setData] = useState({});
	const {header, title, description, slogan, srcDetail} = data;
	const emitter = useStreamActionsSingle();

	const handleProductDetails = (id) => {
		const product = products.find(product => product.id === id);
		const {id: productId, srcDetail, title, type} = product || {};
		const productTitle = `${checkIsBundle(type) ? TEXT_GOMLVL_LONG + ' | ' : ''}${title}`;

		const overlayDataSet = {
			id: productId,
			srcDetail,
		};

		const selections = getAllSelections();
		const productProps = selections.find(el => el.id === productId);
		const titlePrefix = get(productProps, 'quantity', null);

		API.getProductDetails(id)
			.then(res => {
				setData({
					...res,
					...overlayDataSet,
					title: titlePrefix
						? `${titlePrefix}x ${productTitle}`
						: productTitle,
				});
				toggleProductsDetails(true)
			})
			.catch(() => {
				toggleProductsDetails(false);
			});

		const isBundle = checkIsBundle(type);
		if (!isBundle) {
			emitter.client.emitUIInteraction({
				[ACTION_ISOLATE_ITEM]: id,
			});
		}
	}

	const applyProductIconData = () => {
		const iconDataSet = getProductsBrandLogo(title);
		setIconData(iconDataSet?.iconData ?? null);
	}

	const onClose = useCallback(() => {
		const product = products.find(el => el.id === productDetailsId);
		const _isBundle = checkIsBundle(product?.type);
		const res = {};

		if(!_isBundle) {
			emitter.client.emitUIInteraction({
				[ACTION_ISOLATE_ITEM_DISABLED]: 1
			})
			if(!streamStore[SYSTEM_ID_TOGGLE_INSPECT]) {
				res[SYSTEM_ID_TOGGLE_INSPECT] = 1;
			}
		}

		res[ISOLATED_PRODUCT] = null;
		setStreamStore(res)

		toggleProductsDetails(false);
		setTimeout(() => {
			toggleStickyPanel(false)
		}, 800);

	}, [
		emitter,
		setStreamStore,
		productDetailsId,
		toggleProductsDetails,
	]);

	// const titleChanged = useMemo(() => {
	// 	getAllSelections().find(el => el.id === )
	// }, [getAllSelections])

	useEffect(applyProductIconData, [title]);

	useEffect(() => {
		const isolatedId = streamStore[ISOLATED_PRODUCT];
		if(isolatedId) {
			const product = products.find(product => product.id === isolatedId);
			if(product && product?.type !== activeTabId) {
				setActiveTabId(product.type);
			}
			if(isStickyPanelCollapsed) {
				toggleStickyPanel(false)
			}
		}
		setProductDetailsId(isolatedId)
	}, [streamStore[ISOLATED_PRODUCT]])

	useEffect(() => {
		if(productDetailsId) {
			handleProductDetails(productDetailsId)
		} else {
			toggleProductsDetails(false)
		}
	}, [productDetailsId])

	return (
		<div className={classNames('product-details-container', {
			active: isProductDetailsOpen,
		})}>
			<IconClose onClick={onClose}/>
			<ScrollableArea className="product-details-scrollable">
				<div className="product-details-content">
					{title && <TitledName title={title} className="product-details-title"/>}
					{header && <p className="product-details-header">{header}</p>}
					{description &&
						<p className="product-details-description" dangerouslySetInnerHTML={{__html: description}}></p>}
					{slogan && <p className="product-details-slogan">{slogan}</p>}
					{iconData && <IconButton
						IconComponent={iconData.IconComponent}
						height={iconData.height}
						fill={'#fff'}
					/>}
					<div className="product-details-img-wrap">
						<img src={srcDetail} alt={title}/>
					</div>
				</div>
			</ScrollableArea>
		</div>
	)
}

ProductDetails.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	srcDetail: PropTypes.string,
	header: PropTypes.string,
	slogan: PropTypes.string,
}
